import type { GameMode, RunResult } from "./types";

/** Build the human-readable share text for a completed run. */
export function buildShareText(
  mode: GameMode,
  primary: RunResult,
  bch: RunResult,
  btc: RunResult,
): string {
  const other = mode === "BCH" ? btc : bch;
  const outcome = primary.survived ? "survived" : "went broke";
  const feeDiff = Math.max(0, btc.totalFeesUsd - bch.totalFeesUsd);
  const earnDiff = Math.max(0, bch.totalEarnedUsd - btc.totalEarnedUsd);

  const lines = [
    `I ${outcome} 7 days in "Survive on BCH"! 🟢`,
    `Playing ${mode} Mode — Score: ${primary.score}`,
    `Spent + earned all week. Sim. fees: $${primary.totalFeesUsd.toFixed(2)} (vs $${other.totalFeesUsd.toFixed(2)} in ${other.mode} Mode)`,
    btc.spikeFeesUsd > 0
      ? `A BTC congestion spike alone cost $${btc.spikeFeesUsd.toFixed(2)} — BCH's fee never budged. ⚡`
      : feeDiff > 0.5
        ? `Paying in BCH would've saved ~$${feeDiff.toFixed(2)} in fees vs BTC.`
        : "",
    earnDiff > 0.5
      ? `Getting paid in BCH kept ~$${earnDiff.toFixed(2)} more of my income than BTC. 💰`
      : "",
    `(All simulated — no real money.)`,
    `#BitcoinCash #BCH`,
  ].filter(Boolean);

  return lines.join("\n");
}

/** Open X (Twitter) intent in a new tab. */
export function shareToX(text: string, url: string) {
  const intent = new URL("https://twitter.com/intent/tweet");
  intent.searchParams.set("text", text);
  intent.searchParams.set("url", url);
  window.open(intent.toString(), "_blank", "noopener,noreferrer");
}
